import { render, staticRenderFns } from "./offers-list.vue?vue&type=template&id=71de56ab&"
import script from "./offers-list.vue.ts?vue&type=script&lang=ts&"
export * from "./offers-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports